import React from 'react';

import { Container } from './styles';

const PublicLayout: React.FC = ({ children }) => {
  return <Container>{children}</Container>;
};

export default PublicLayout;
